class A1PurchaseSummary extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    const section = this.closest('.shopify-section');
    this.price = Number(this.dataset.price);
    this.available = Boolean(this.dataset.price);
    const update = () => this.update();
    section?.addEventListener('variant:selected', () => { this.setAttribute('aria-busy', 'true'); this.querySelector('.a1-purchase-total')?.setAttribute('hidden', ''); }, { signal });
    section?.addEventListener('variant:update', (event) => {
      if (String(event.detail.data.productId) !== this.dataset.productId) return;
      const fresh = event.detail.data.html.querySelector('a1-purchase-summary');
      this.price = Number(fresh?.dataset.price);
      this.available = Boolean(event.detail.resource);
      this.removeAttribute('aria-busy');
      queueMicrotask(update);
    }, { signal });
    this.closest('product-form-component')?.addEventListener('input', update, { signal });
    this.closest('product-form-component')?.addEventListener('change', update, { signal });
    section?.addEventListener('quantity-selector:update', update, { signal });
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); }
  update() {
    const row = this.querySelector('.a1-purchase-total');
    if (!row || this.dataset.currency !== 'DKK') return;
    row.hidden = !this.available;
    if (!this.available) return;
    const input = this.closest('product-form-component')?.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, Number(input?.value) || 1);
    const subtotal = this.price * quantity;
    const shipping = subtotal >= Number(this.dataset.threshold) ? 0 : Number(this.dataset.shipping);
    const money = (amount) => new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(amount / 100);
    this.querySelector('[data-a1-total]').textContent = money(subtotal + shipping);
    this.querySelector('[data-a1-shipping]').textContent = shipping ? money(shipping) : this.dataset.freeLabel;
  }
}
if (!customElements.get('a1-purchase-summary')) customElements.define('a1-purchase-summary', A1PurchaseSummary);

function labelProductColors(root) {
  root.querySelectorAll('.fd-options-swatch__options a.pg-product').forEach((link) => {
    if (link.hasAttribute('aria-label')) return;
    const name = link.querySelector('.fd-floating-tooltip')?.childNodes[0]?.textContent?.trim();
    if (!name) return;
    link.setAttribute('aria-label', root.dataset.colorLabel.replace('__COLOR__', name));
    link.title = name;
    if (link.classList.contains('active')) link.setAttribute('aria-current', 'page');
  });
}
document.querySelectorAll('.a1-pdp').forEach((root) => {
  labelProductColors(root);
  new MutationObserver(() => labelProductColors(root)).observe(root, { childList: true, subtree: true });
});
